import desintegrador1 from '../desintegrador/desintegrador1.png'


const desintegradorImages = [
    desintegrador1,
]

export default desintegradorImages